import { PaintedScene } from '../PaintedScene';

export const WEEPING_STANDING_STONE_PHASER_KEY = 'WeepingStandingStoneScene' as const;
export const WEEPING_STANDING_STONE_MANIFEST_KEY = 's-104-weeping-standing-stone' as const;

export class WeepingStandingStoneScene extends PaintedScene {
  constructor() {
    super(WEEPING_STANDING_STONE_PHASER_KEY, WEEPING_STANDING_STONE_MANIFEST_KEY);
  }
}
